import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'

import Wrapper from '../../components/Wrapper'
import Header from '../../components/Header'
import TopBar from '../../components/TopBar'
import ErrorImage from '../../assets/motor/error_payment.png'

import _ from 'lodash'

const fontDefault = {
  fontFamily: 'thonburiregular',
  fontStyle: 'normal',
}

const styles = {}

class ErrorPayment extends Component {
  state = {
    errorMessage: '',
  }
  componentDidMount = () => {
    const { history } = this.props
    const { location } = history
    const splittedData = _.get(location, 'search', '')
      .slice(1, _.get(location, 'search.length', 0))
      .split('&')
    const params = {}
    splittedData.forEach(data => {
      const splitMore = data.split('=')
      const key = splitMore[0]
      const value = splitMore[1]
      params[key] = value
    })
    this.setState({
      errorMessage: decodeURIComponent(_.get(params, 'message', '')),
    })
  }

  render() {
    const { errorMessage } = this.state
    return (
      <Wrapper>
        <div style={{ margin: '16px', marginTop: '66px' }}>
          <div
            style={{
              marginTop: '16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img
              alt="error_image"
              src={ErrorImage}
              style={{ width: '120px', height: '120px' }}
            />
          </div>
          <p
            style={{
              ...fontDefault,
              textAlign: 'center',
              fontWeight: 'bold',
              fontSize: '18px',
              color: '#0e162c',
            }}
          >
            ชำระเงินไม่สำเร็จ
          </p>
          <p
            style={{
              ...fontDefault,
              textAlign: 'center',
              fontSize: '16px',
              color: '#999999',
            }}
          >
            ไม่สามารถทำรายการชำระเงิน ได้ในขณะนี้ กรุณาทำรายการใหม่อีกครั้ง
          </p>
          {!!!errorMessage && <br />}
          {!!errorMessage && (
            <div>
              <p
                style={{
                  ...fontDefault,
                  textAlign: 'center',
                  fontSize: '16px',
                  color: '#999999',
                }}
              >
                {errorMessage}
              </p>
              <br />
            </div>
          )}

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <a
              href="ascendmoney://closewebview"
              style={{
                ...fontDefault,
                color: '#ff8300',
                padding: '7px 20px',
                fontWeight: 'bold',
                border: '1px solid #ff8300',
                borderRadius: '20px',
                backgroundColor: 'white',
                textDecoration: 'none',
              }}
            >
              ตกลง
            </a>
          </div>
        </div>
        <Header>
          <TopBar
            close={() => {
              window.location.replace('ascendmoney://closewebview')
            }}
          />
        </Header>
      </Wrapper>
    )
  }
}
const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {}
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ErrorPayment))
